import { ROLE_ADMIN } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN],
    layout: 'ordit-authenticated-layout',
}

const breadCrumbs = {
    list: {
        to: {
            name: routeType.COUPON_LIST,
        },
        text: 'menu.coupons',
    },
    edit: {
        to: {
            name: routeType.COUPON_EDIT,
        },
        label: '...',
    },
}

export default [
    {
        path: '/coupons',
        component: {
            render: (c) => c('router-view'),
        },
        meta: {
            ...meta,
            breadcrumb: breadCrumbs.list,
        },
        children: [
            {
                path: '',
                name: routeType.COUPON_LIST,
                component: () =>
                    import(
                        /* webpackChunkName: "promo-list" */ '@/pages/coupons/List.vue'
                    ),
                meta,
            },
            {
                path: 'create',
                name: routeType.COUPON_CREATE,
                component: () =>
                    import(
                        /* webpackChunkName: "promo-edit" */ '@/pages/coupons/Create.vue'
                    ),
                meta: {
                    ...meta,
                    breadcrumb: breadCrumbs.edit,
                },
            },
            {
                path: ':id',
                name: routeType.COUPON_EDIT,
                component: () =>
                    import(
                        /* webpackChunkName: "promo-edit" */ '@/pages/coupons/Edit.vue'
                    ),
                meta: {
                    ...meta,
                    breadcrumb: breadCrumbs.edit,
                },
            },
        ],
    },
]
